/**
 * Admin 独立页：我的好友（主号直推）— 搜账号后查看直推列表。
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Space, Typography, message } from 'antd';
import { DirectFriendsPanel } from '../../components/DirectFriendsPanel';

export function AdminMyFriendsPage() {
  const navigate = useNavigate();
  const [input, setInput] = useState('');
  const [lookup, setLookup] = useState<{ playerNumber?: string; account?: string } | null>(null);

  function runSearch() {
    const q = input.trim();
    if (!q) {
      message.info('请输入玩家编号或账号');
      return;
    }
    if (/^\d+$/.test(q)) setLookup({ playerNumber: q });
    else setLookup({ account: q });
  }

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>我的好友</h2>
      <Typography.Paragraph type="secondary">
        查看某账号的<strong>主号直推</strong>（与前台「我的好友」同口径：Node{' '}
        <code>referrer_id</code>，不含子账户）。可从侧栏进入，或在系谱图全球玩家表点「好友」。
      </Typography.Paragraph>

      <Space wrap style={{ marginBottom: 16 }}>
        <Input
          placeholder="玩家编号或账号，如 100243 / ABAB111"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onPressEnter={runSearch}
          style={{ width: 280 }}
          allowClear
        />
        <Button type="primary" onClick={runSearch}>
          查询
        </Button>
        {lookup ? (
          <Button
            type="link"
            onClick={() => {
              setLookup(null);
              setInput('');
            }}
          >
            清除
          </Button>
        ) : null}
      </Space>

      {lookup ? (
        <DirectFriendsPanel
          playerNumber={lookup.playerNumber}
          account={lookup.account}
          onOpenPlayer={(num) => {
            navigate(`/platform/binary_tree?root=${encodeURIComponent(num)}`);
          }}
        />
      ) : (
        <Typography.Text type="secondary">输入编号或账号后查询直推列表。</Typography.Text>
      )}
    </div>
  );
}

export default AdminMyFriendsPage;
